// Company Profile — the facts the orio360.com website shows (website plan §6.2).
// Mirrors `platform_company_profile` (migration 20261231210000).

export const SOCIAL_LINK_KEYS = ['facebook', 'instagram', 'linkedin', 'youtube', 'x'] as const;
export type SocialLinkKey = (typeof SOCIAL_LINK_KEYS)[number];
export type SocialLinks = Partial<Record<SocialLinkKey, string>>;

/** GET /platform/company-profile — every column. */
export interface CompanyProfile {
  id: number;
  brand_name: string;
  legal_name: string | null;
  address_line1: string | null;
  address_line2: string | null;
  city: string | null;
  state: string | null;
  pincode: string | null;
  country: string;
  phone: string | null;
  whatsapp: string | null;
  support_email: string;
  enquiry_email: string;
  send_enquiry_ack: boolean;
  business_hours: string | null;
  founded_year: number | null;
  story: string | null;
  gstin: string | null;
  show_gstin: boolean;
  pricing_note: string;
  social_links: SocialLinks;
  updated_by: string | null;
  /** null only when the profile was never saved. */
  created_at: string | null;
  updated_at: string | null;
}

/** PUT /platform/company-profile. A field left out is not changed; null clears it. */
export type UpdateCompanyProfileInput = Partial<
  Omit<CompanyProfile, 'id' | 'updated_by' | 'created_at' | 'updated_at'>
>;
